import { createSlice } from "@reduxjs/toolkit";

const adsInfoSlice = createSlice({
  name: "adsInfos",
  initialState: {
    isFetching: false,
    adsInfos: [],
    error: []
  },
  reducers: {
    statusAdsInfoStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusAdsInfoSuccess: (state, action) => {
      state.isFetching = false
      state.adsInfos = action.payload
      state.error = []
    },
    statusAdsInfoFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusAdsInfoStart,
  statusAdsInfoSuccess,
  statusAdsInfoFailure 
} = adsInfoSlice.actions

export default adsInfoSlice.reducer